import { Form, InputNumber, Select, Spin } from "antd";
import { Button as PrimeBtn } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";

import { updateQCer } from "../../../apis/SettingApis";
import { Option } from "antd/lib/mentions";

const UpdateQualityCheckerAutoAssign = (props) => {
    const [apiLoading, setApiLoading] = useState(false);
    const toast = useRef(null);
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue({
            level: props.user?.level,
            priority: props.user?.priority,
            maxAssignmentBeforeNext: props.user?.maxAssignmentBeforeNext || 0
        });
    }, [props]);

    const handleSubmit = () => {
        form.validateFields().then((values) => {
            values.id = props.user?.id;
            setApiLoading(true);
            updateQCer(values).then((res) => {
                if (res.status === 200) {
                    toast.current.show({
                        severity: "success",
                        summary: "Status",
                        detail: "Update User successfully",
                        life: 3000
                    });
                    props.setVisible(false);
                } else {
                    toast.current.show({
                        severity: "warn",
                        summary: "Status",
                        detail: "Update User failed",
                        life: 3000
                    });
                    props.setVisible(false);
                }
                setApiLoading(false);
            }).catch((e) => {
                toast.current.show({
                    severity: "error",
                    summary: "Status",
                    detail: e,
                    life: 3000,
                });
                setApiLoading(false);
            });
        });
    };

    return (
        <React.Fragment>
            <Toast ref={toast} />
            <Dialog
                style={{ width: "660px" }}
                header={"Update User: " + props.user?.username}
                visible={props.visible}
                onHide={() => { props.setVisible(false); }}
            >
                <Spin spinning={apiLoading}>
                    <div className='flex justify-content-between align-items-center'>
                        <Form form={form} onFinish={handleSubmit}>
                            <Form.Item
                                required={true}
                                name="priority"
                                label="Order who to assign first"
                                labelCol={{ span: 9 }}
                                labelAlign="left"
                            >
                                <InputNumber
                                    style={{ width: "400px" }}
                                    onKeyDown={(e) => e.stopPropagation()}
                                />
                            </Form.Item>
                            <Form.Item
                                required={true}
                                name="maxAssignmentBeforeNext"
                                label="Assign amount before moving to next"
                                labelCol={{ span: 9 }}
                                labelAlign="left"
                            >
                                <InputNumber
                                    style={{ width: "400px" }}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    placeholder="Enter number of projects"
                                />
                            </Form.Item>
                            <Form.Item
                                required={true}
                                name="level"
                                label="Type/ Level"
                                labelCol={{ span: 9 }}
                                labelAlign="left"
                            >
                                <Select
                                    style={{ width: 400 }}
                                    dropdownStyle={{ zIndex: "9999" }}
                                    placeholder="Select"
                                >
                                    <Option value="A">A</Option>
                                    <Option value="B">B</Option>
                                    <Option value="C">C</Option>
                                    <Option value="D">D</Option>
                                    <Option value="E">E</Option>
                                </Select>
                            </Form.Item>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <PrimeBtn
                                    style={{
                                        backgroundColor: "#037eea",
                                        borderColor: "#037eea",
                                        float: "right",
                                        marginRight: "1rem",
                                    }}
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </Form>
                    </div>
                </Spin>
            </Dialog>
        </React.Fragment>
    );
};

export default UpdateQualityCheckerAutoAssign;
